import { render, staticRenderFns } from "./CreateFacebookCarrousel.vue?vue&type=template&id=7be714d4&scoped=true&"
import script from "./CreateFacebookCarrousel.vue?vue&type=script&lang=js&"
export * from "./CreateFacebookCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./CreateFacebookCarrousel.vue?vue&type=style&index=0&id=7be714d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be714d4",
  null
  
)

export default component.exports